// src/pages/Auth/LoginPage.jsx
import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';
import { AuthContext } from '../../context/AuthContext';
import { FaDiscord } from 'react-icons/fa';

const LoginPage = ({ isStaff = false }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { handleLogin } = useContext(AuthContext);

  const handleDiscordLoginClick = async () => {
    try {
      const apiBase = process.env.REACT_APP_API_BASE_URL || 'https://riasbaixaspd.es/api';
      const response = await fetch(`${apiBase}/auth/discord/url`);
      if (!response.ok) {
        throw new Error('No se pudo obtener la URL de autorización de Discord.');
      }
      const data = await response.json();
      window.location.href = data.url;
    } catch (err) {
      setError('Error al conectar con Discord: ' + err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const loginSuccess = await handleLogin(username, password);

      if (!loginSuccess) {
        throw new Error('Usuario o contraseña incorrectos');
      }

      if (loginSuccess.role === 'superadmin' || loginSuccess.permissions.includes('ver_dashboard')) {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      let msg = err.message;
      if (msg && msg.startsWith('{') && msg.includes('message')) {
        try {
          const parsed = JSON.parse(msg);
          msg = parsed.message || 'Error al iniciar sesión. Verifica tus credenciales.';
        } catch {}
      }
      setError(typeof msg === 'string' && msg.trim() ? msg : 'Error al iniciar sesión. Verifica tus credenciales.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-background-overlay"></div>
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo-container">
            <h1 className="login-brand">Rias Baixas PD</h1>
            <p className="login-subtitle">
              {isStaff ? 'Panel de Administración y Staff' : 'Panel de Usuario y Ciudadanos'}
            </p>
          </div>
        </div>
        
        <div className="login-card">
          <h2 className="login-title">
            {isStaff ? 'Iniciar Sesión (Staff)' : 'Iniciar Sesión'}
          </h2>
          
          {error && error.trim() && (
            <div className="error-message">
              <i className="error-icon">⚠</i>
              <span>{error}</span>
            </div>
          )}

          {!isStaff ? (
            <>
              <p style={{ color: '#bbb', fontSize: '0.95rem', textAlign: 'center', marginBottom: '25px', lineHeight: '1.5' }}>
                Accede con tu cuenta de Discord para rellenar tu solicitud de Whitelist o comprobar su estado actual.
              </p>
              <button type="button" onClick={handleDiscordLoginClick} className="discord-login-button" style={{ marginBottom: '20px' }}>
                <FaDiscord className="discord-icon" />
                <span>Entrar con Discord</span>
              </button>
              <div className="login-divider">O ACCESO STAFF</div>
              <Link to="/login/staff" className="login-footer-link" style={{ display: 'block', textAlign: 'center', color: '#1CA7EC', textDecoration: 'none', fontWeight: '500', marginTop: '10px' }}>
                Iniciar sesión como Staff
              </Link>
            </>
          ) : (
            <>
              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Usuario de Staff"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Contraseña"
                    required
                  />
                </div>
                
                <button type="submit" className="login-button" style={{ marginTop: '10px' }}>
                  <span>Acceder al Panel</span>
                </button>
              </form>
              <div className="login-divider">O VOLVER</div>
              <Link to="/login" className="login-footer-link" style={{ display: 'block', textAlign: 'center', color: '#bbb', textDecoration: 'none', fontWeight: '500', marginTop: '10px' }}>
                Iniciar sesión como Ciudadano
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
